/**
 * Security Store (Zustand)
 *
 * Manages security dashboard UI state:
 * - Alert banner visibility (per-session dismissals)
 * - Alert and tunnel filters
 * - Selected site for drill-down
 */

import { create } from 'zustand';

interface SecurityState {
  // Alert banner
  dismissedAlertIds: Set<string>;
  dismissAlert: (alertId: string) => void;

  // Filters
  alertSeverityFilter: string | undefined;
  alertStatusFilter: string | undefined;
  alertCategoryFilter: string | undefined;
  setAlertSeverityFilter: (severity: string | undefined) => void;
  setAlertStatusFilter: (status: string | undefined) => void;
  setAlertCategoryFilter: (category: string | undefined) => void;
  resetAlertFilters: () => void;

  // Selected site for traffic chart drill-down
  selectedSiteId: string | undefined;
  setSelectedSiteId: (siteId: string | undefined) => void;

  // Traffic time range
  trafficTimeRange: '15m' | '1h' | '24h' | '7d';
  setTrafficTimeRange: (range: '15m' | '1h' | '24h' | '7d') => void;
}

export const useSecurityStore = create<SecurityState>((set) => ({
  dismissedAlertIds: new Set(),
  dismissAlert: (alertId) =>
    set((state) => ({
      dismissedAlertIds: new Set(state.dismissedAlertIds).add(alertId),
    })),

  alertSeverityFilter: undefined,
  alertStatusFilter: undefined,
  alertCategoryFilter: undefined,
  setAlertSeverityFilter: (severity) => set({ alertSeverityFilter: severity }),
  setAlertStatusFilter: (status) => set({ alertStatusFilter: status }),
  setAlertCategoryFilter: (category) => set({ alertCategoryFilter: category }),
  resetAlertFilters: () =>
    set({
      alertSeverityFilter: undefined,
      alertStatusFilter: undefined,
      alertCategoryFilter: undefined,
    }),

  selectedSiteId: undefined,
  setSelectedSiteId: (siteId) => set({ selectedSiteId: siteId }),

  trafficTimeRange: '1h',
  setTrafficTimeRange: (range) => set({ trafficTimeRange: range }),
}));
